module.exports = __webpack_public_path__ + "static/media/arrowLeft.11b161d8.svg";